import { Component } from '@angular/core';
import { Paths } from '../../enums/paths.enum';
import { RouteLabels } from '../../enums/routeLabels.enum';

@Component({
    selector: 'app-companies',
    template: ` <app-aumico-layout>
        <ng-container header>
            <ham-page-header [hasBackButton]="false" [title]="pageHeader.value"></ham-page-header>
            <ham-page-tab-navigation [navigationItems]="activeNavigationTabs"></ham-page-tab-navigation>
        </ng-container>
        <ng-container content>
            <router-outlet></router-outlet>
        </ng-container>
    </app-aumico-layout>`,
})
export class UserAccountPage {
    pageHeader = {
        isLocalizedKey: true,
        value: RouteLabels.USER_ACCOUNT,
    };

    public activeNavigationTabs: {
        routerLink: string;
        tabLabelKey: string;
    }[] = [
        {
            routerLink: Paths.USER_GENERAL_INFORMATION,
            tabLabelKey: RouteLabels.USER_GENERAL_INFORMATION,
        },
        {
            routerLink: Paths.USER_SECURITY,
            tabLabelKey: RouteLabels.USER_SECURITY,
        },
    ];
}
